export default __webpack_public_path__ + "static/media/monitor.64dca6bf.svg";